import { MachineState } from './types';

export const RESPONSE_TIMEOUT = 30000;

export const TIMED_ORCHESTRATOR_STATES: MachineState[] = [
    'retryGettingLinkedTextResponse',
    'waitingForResponse',
    'updatingSearchResults',
    'waitingForListingAttributesResponse',
];

export const ORCHESTRATOR_MACHINE_METRIC_PREFIX = 'listings.listings_orchestrator_machine';
